const theme = {
  bg: '#0e0c0a',
  surface1: '#1a1714',
  surface2: '#231f1c',
  surface3: '#2d2825',
  border1: 'rgba(255,255,255,0.06)',
  border2: 'rgba(255,255,255,0.10)',
  border3: 'rgba(255,255,255,0.18)',
  text1: '#f5f0e8',
  text2: 'rgba(245,240,232,0.6)',
  text3: 'rgba(245,240,232,0.35)',
  gold: '#d4a843',
  goldDim: '#c8973a',
  goldGlow: 'rgba(212,168,67,0.15)',
  goldGlowStrong: 'rgba(212,168,67,0.3)',
  green: '#3dba6e',
  greenGlow: 'rgba(61,186,110,0.15)',
  red: '#e05252',
  redGlow: 'rgba(224,82,82,0.15)',
  amber: '#d4882a',
  amberGlow: 'rgba(212,136,42,0.15)',
  purple: '#8b6fd4',
  purpleGlow: 'rgba(139,111,212,0.15)',
  purpleGlowStrong: 'rgba(139,111,212,0.25)',
  fontDisplay: "'DM Serif Display', Georgia, serif",
  fontBody: "'DM Sans', -apple-system, sans-serif",
  fontMono: "'JetBrains Mono', 'Courier New', monospace",
  shadow1: '0 1px 3px rgba(0,0,0,0.3)',
  shadow2: '0 4px 16px rgba(0,0,0,0.4)',
  shadow3: '0 8px 32px rgba(0,0,0,0.5)',
  shadow4: '0 24px 64px rgba(0,0,0,0.6)',
  r1: '8px',
  r2: '12px',
  r3: '16px',
  r4: '20px',
  r5: '24px',
  // Legacy aliases so existing code doesn't break
  primary: '#d4a843',
  primaryDark: '#b8872d',
  primaryText: '#0e0c0a',
  text: '#f5f0e8',
  textSecondary: 'rgba(245,240,232,0.6)',
  textTertiary: 'rgba(245,240,232,0.35)',
  surface: '#1a1714',
  surfaceAlt: '#231f1c',
  border: 'rgba(255,255,255,0.10)',
  borderSoft: 'rgba(255,255,255,0.06)',
  borderStrong: 'rgba(255,255,255,0.18)',
  purpleDark: '#6b52a8',
  purpleSoft: 'rgba(139,111,212,0.1)',
  purpleBorder: 'rgba(139,111,212,0.2)',
  greenSoft: 'rgba(61,186,110,0.1)',
  redSoft: 'rgba(224,82,82,0.08)',
  goldSoft: 'rgba(212,168,67,0.1)',
  goldBorder: 'rgba(212,168,67,0.2)',
  blue: '#3b6fb5',
  blueSoft: 'rgba(59,111,181,0.1)',
  white: '#ffffff',
  radius: { xs: 6, sm: 10, md: 14, lg: 16, xl: 20, xxl: 24, full: 999 },
  shadow: {
    sm: '0 1px 3px rgba(0,0,0,0.3)',
    md: '0 4px 16px rgba(0,0,0,0.4)',
    lg: '0 8px 32px rgba(0,0,0,0.5)',
    xl: '0 24px 64px rgba(0,0,0,0.6)',
  },
  space: { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 48, xxxxl: 64 },
  type: { caption: 11, small: 12, base: 13, md: 14, lg: 16, xl: 20, xxl: 24, h1: 32, display: 48 },
  weight: { regular: 400, medium: 500, semibold: 600, bold: 700, black: 800, ultra: 900 },
  transition: 'all 0.15s ease',
  transitionMd: 'all 0.2s ease',
  focusRing: '0 0 0 3px rgba(212,168,67,0.25)',
  focusRingPurple: '0 0 0 3px rgba(139,111,212,0.25)',
  minTapTarget: 44,
};

export const getTheme = (isDark) => isDark ? {
  // ── Backgrounds ──
  bg: '#13100e',
  surface: '#1e1a17',
  surface2: '#2a2420',
  surface3: '#342e2b',
  // ── Text ──
  text: '#f5f0e8',
  textSec: 'rgba(245,240,232,0.55)',
  textTert: 'rgba(245,240,232,0.35)',
  textSecondary: 'rgba(245,240,232,0.55)',
  textTertiary: 'rgba(245,240,232,0.35)',
  // ── Borders ──
  border: 'rgba(255,255,255,0.08)',
  border2: 'rgba(255,255,255,0.12)',
  borderSoft: 'rgba(255,255,255,0.05)',
  // ── Gold ──
  gold: '#d4a843',
  goldDim: '#b8872d',
  goldGlow: 'rgba(212,168,67,0.12)',
  goldGlowStrong: 'rgba(212,168,67,0.28)',
  goldBorder: 'rgba(212,168,67,0.25)',
  goldSoft: 'rgba(212,168,67,0.09)',
  // ── Purple ──
  purple: '#8b6fd4',
  purpleGlow: 'rgba(139,111,212,0.15)',
  purpleGlowStrong: 'rgba(139,111,212,0.22)',
  // ── Green ──
  green: '#3dba6e',
  greenGlow: 'rgba(61,186,110,0.12)',
  greenSoft: 'rgba(61,186,110,0.09)',
  // ── Red ──
  red: '#e05252',
  redGlow: 'rgba(224,82,82,0.12)',
  redSoft: 'rgba(224,82,82,0.09)',
  // ── Amber ──
  amber: '#d4882a',
  // ── Shadows ──
  shadow1: '0 1px 3px rgba(0,0,0,0.4)',
  shadow2: '0 4px 16px rgba(0,0,0,0.5)',
  shadow3: '0 8px 32px rgba(0,0,0,0.6)',
} : {
  // ── Backgrounds ── warm paper palette
  bg: '#FAFAF7',
  surface: '#FFFFFF',
  surface2: '#F5F2EA',
  surface3: '#EDE9DF',
  // ── Text ──
  text: '#1C1917',
  textSec: '#6B6560',
  textTert: '#9B948E',
  textSecondary: '#6B6560',
  textTertiary: '#9B948E',
  // ── Borders ──
  border: 'rgba(28,25,23,0.09)',
  border2: 'rgba(28,25,23,0.15)',
  borderSoft: 'rgba(28,25,23,0.06)',
  // ── Gold ──
  gold: '#C8973A',
  goldDim: '#A07828',
  goldGlow: 'rgba(200,151,58,0.1)',
  goldGlowStrong: 'rgba(200,151,58,0.22)',
  goldBorder: 'rgba(200,151,58,0.3)',
  goldSoft: 'rgba(200,151,58,0.08)',
  // ── Purple ──
  purple: '#6D5BD0',
  purpleGlow: 'rgba(109,91,208,0.1)',
  purpleGlowStrong: 'rgba(109,91,208,0.2)',
  // ── Green ──
  green: '#2D7A4F',
  greenGlow: 'rgba(45,122,79,0.1)',
  greenSoft: 'rgba(45,122,79,0.08)',
  // ── Red ──
  red: '#C0392B',
  redGlow: 'rgba(192,57,43,0.1)',
  redSoft: 'rgba(192,57,43,0.07)',
  // ── Amber ──
  amber: '#B45309',
  // ── Shadows ── much lighter for light bg
  shadow1: '0 1px 4px rgba(0,0,0,0.06)',
  shadow2: '0 4px 16px rgba(0,0,0,0.08)',
  shadow3: '0 8px 32px rgba(0,0,0,0.1)',
};

export const statusColor = (status) =>
  status === 'green' ? theme.green : status === 'amber' ? theme.amber : theme.red;
export const statusLabel = (status) =>
  status === 'green' ? 'Confident' : status === 'amber' ? 'In progress' : 'Gap';
export const gradientPrimary = `linear-gradient(135deg, ${theme.gold} 0%, ${theme.primaryDark} 100%)`;
export const gradientGold = `linear-gradient(135deg, ${theme.gold} 0%, ${theme.primaryDark} 100%)`;
export const gradientPurple = `linear-gradient(135deg, ${theme.purple} 0%, ${theme.purpleDark} 100%)`;
export const gradientDark = `linear-gradient(135deg, #0e0c0a 0%, #1a1714 50%, #0e0c0a 100%)`;

export default theme;
